<template>
    <div>
      <h4>{{characteristic.name}}</h4>
      <v-spacer />
  
      <v-divider></v-divider>
        <v-row v-for="(value, key) in characteristic" :key="key">
          <v-col v-if="Array.isArray(value) && key != 'customFields' && value != null">
            <div class="fieldname">{{ decodeCharacteristicFieldToName(key) }}</div>
            <ColorLegend :items="characteristic[key]" chip-class="mr-2">
              <template #default="{ item }">
                {{ item.friendlyName }}
              </template>
            </ColorLegend>
          </v-col>
          <v-col v-if="key == 'connectedModelId'">
            <div class="fieldname">{{ decodeCharacteristicFieldToName(key) }}</div>
            <v-btn :disabled="value == null" color="secondary" @click="openProcessModel(value)">
              <v-icon>mdi-open-in-new</v-icon>
              Prozessmodell öffnen
            </v-btn>
          </v-col>
          <v-col v-else-if="!Array.isArray(value) && key != 'customFields' && !key.toUpperCase().includes('CONNECTEDMODEL') && value != null">
            <div class="fieldname">{{ decodeCharacteristicFieldToName(key) }}</div>
            <div v-if="!key.toUpperCase().includes('DATE')" class="fieldvalue">{{ value }}</div>
            <div v-else class="fieldvalue">{{ value | moment("DD.MM.YYYY HH:mm") }}</div>
          </v-col>
        </v-row>
        <v-row v-for="field in characteristic.customFields" :key="field.id">
          <v-col v-if="field.fieldValue != null">
            <div class="fieldname">{{ field.customField.name }}</div> <!-- Feldname Celina-->
            <div class="fieldvalue">{{ field.fieldValue }}</div><!-- Feldwert Celina-->
          </v-col>
        </v-row>
  </div>

</template>

<script>
import {decodeCharacteristicFieldToName} from '@/components/util.js'
import ColorLegend from "@/pages/ProcessMap/ColorLegend.vue";
export default {
  components: {ColorLegend},
  props:{
    characteristic: Object
  },
  methods: {
    decodeCharacteristicFieldToName: decodeCharacteristicFieldToName,
    close(){
        this.$emit("close");
    },
    openProcessModel(uuid){
      const routeURL = this.$router.resolve({ path: '/modelEdit/'+uuid }).href;
      window.open(routeURL, '_blank')
    }
  },
}
</script>

<style scoped>
.v-tooltip__content {
  pointer-events: initial !important;
  background: none;
}
</style>